export function formatDate(value: string | null | undefined, withTime = false) {
  if (!value) return "未设置";
  const date = withTime ? new Date(value) : new Date(`${value.slice(0, 10)}T00:00:00`);
  if (Number.isNaN(date.getTime())) return value;
  return new Intl.DateTimeFormat("zh-CN", {
    year: "numeric",
    month: "short",
    day: "numeric",
    ...(withTime ? { hour: "2-digit", minute: "2-digit" } : {}),
  }).format(date);
}

export function formatRelative(value: string | null | undefined) {
  if (!value) return "尚未更新";
  const date = new Date(value);
  const diff = date.getTime() - Date.now();
  const absMinutes = Math.abs(Math.round(diff / 60_000));
  if (absMinutes < 1) return "刚刚";
  if (absMinutes < 60) return `${absMinutes} 分钟前`;
  const hours = Math.round(absMinutes / 60);
  if (hours < 24) return `${hours} 小时前`;
  return formatDate(value);
}

export function formatMoney(cents: number, currency = "CNY") {
  return new Intl.NumberFormat("zh-CN", { style: "currency", currency }).format(cents / 100);
}

export function todayDate() {
  const now = new Date();
  const offset = now.getTimezoneOffset() * 60_000;
  return new Date(now.getTime() - offset).toISOString().slice(0, 10);
}

export function toLocalDateTimeInput(value: string | null | undefined) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";

  const pad = (part: number) => String(part).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export function localDateTimeInputToIso(value: unknown) {
  if (typeof value !== "string" || value.trim() === "") return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date.toISOString();
}

export function safeReturnTo(value: string | null) {
  const fallback = "/dashboard";
  if (!value || !value.startsWith("/") || /[\\\u0000-\u001f\u007f]/.test(value)) return fallback;

  let decoded = value;
  try {
    for (let index = 0; index < 2; index += 1) decoded = decodeURIComponent(decoded);
  } catch {
    return fallback;
  }
  if (decoded.startsWith("//") || /[\\\u0000-\u001f\u007f]/.test(decoded)) return fallback;

  try {
    const base = "https://workbench.invalid";
    const target = new URL(value, base);
    if (target.origin !== base || !target.pathname.startsWith("/")) return fallback;
    return `${target.pathname}${target.search}${target.hash}`;
  } catch {
    return fallback;
  }
}

export function downloadBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
